<template>
    <div class="page-table haberTanim mainDiv listPage" id="affix-container">
        <el-tabs v-if="$store.state.dilDurum" class="hidden-md-and-down language" tab-position="left" v-model="dil"
                 @tab-click="dilChange">
            <el-tab-pane label="tr" name="tr">
                <span slot="label"><i class="flag-icon flag-icon-tr"></i></span>
                <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft"></div>
            </el-tab-pane>
            <el-tab-pane label="en" name="en">
                <span slot="label"><i class="flag-icon flag-icon-gb"></i></span>
                <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft"></div>
            </el-tab-pane>
        </el-tabs>
        <el-radio-group v-if="$store.state.dilDurum" class="hidden-md-and-up" v-model="dil" size="mini"
                        v-on:change="dilChange($event)">
            <el-radio-button label="tr"><i class="flag-icon flag-icon-tr"></i></el-radio-button>
            <el-radio-button label="en"><i class="flag-icon flag-icon-gb"></i></el-radio-button>
        </el-radio-group>
        <div class="card-base baslikBg animated fadeInUp">Sayfa Listesi</div>
        <div class="page-header card-base card-shadow--medium animated fadeInUp">
            <el-col :lg="16" :md="16" :sm="24" :xs="24">
                <div>
                    <el-radio-group size="mini" v-on:change="handleChange($event)" v-model="radio" fill="#E5F5F9"
                                    text-color="gray">
                        <el-radio-button label="1">
                            <i class="mdi mdi-page-next mdi-18px" style="color: #13ce66; margin-right: 5px"></i>
                            <transition
                                    name="slide-fade"><label v-if="selectIcon==='1'">{{$t("src.views.apps.sayfa.liste.yayinda")}}</label>
                            </transition>
                        </el-radio-button>
                        <el-radio-button label="0">
                            <i class="mdi mdi-page-next mdi-18px" style="color: #ec205f; margin-right: 5px"></i>
                            <transition
                                    name="slide-fade"><label v-if="selectIcon==='0'">{{$t("src.views.apps.sayfa.liste.pasif")}}</label>
                            </transition>
                        </el-radio-button>
                    </el-radio-group>
                </div>
            </el-col>
            <el-col :lg="8" :md="8" :sm="24" :xs="24">
                <el-row :gutter="10">
                    <el-col :lg="24" :md="24" :sm="24" :xs="24">
                        <div class="flex">
                            <div class="daireclass margin-left-10"></div>
                            <div class="margin-left-5">Oluşturan</div>
                            <div class="daireclass1 margin-left-10"></div>
                            <div class="margin-left-5">Sayfa Detay</div>
                            <div class="daireclass2 margin-left-10"></div>
                            <div class="margin-left-5">Sayfa Düzenle</div>
                            <div v-if="selectIcon==='1'" class="daireclass3 margin-left-10"></div>
                            <div v-if="selectIcon==='1'" class="margin-left-5">Yayından Kaldır</div>
                            <div v-if="selectIcon==='0'" class="daireclass4 margin-left-10"></div>
                            <div v-if="selectIcon==='0'" class="margin-left-5">Yayına Al</div>
                        </div>
                    </el-col>
                    <el-col :lg="24" :md="24" :sm="24" :xs="24">
                        <el-tooltip :content='$t("src.views.apps.sayfa.tanimlama.title")'
                                    :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    v-on:click="routeSayfa('Sayfa Tanımla')"
                                    style="float: right;"
                                    size="mini"
                                    icon="el-icon-plus">
                            </el-button>
                        </el-tooltip>
                    </el-col>
                </el-row>
            </el-col>
            <el-table
                    :data="sayfalarListesi"
                    style="width: 100%">
                <el-table-column
                        label="Sıra"
                        type="index">
                </el-table-column>
                <el-table-column
                        sortable
                        prop="baslik"
                        label="Başlık"
                        width="auto">
                </el-table-column>
                <el-table-column
                        label="Resim"
                        width="auto">
                    <template slot-scope="scope">
                        <el-popover
                                transition="el-fade-in-linear"
                                placement="left"
                                width="auto"
                                trigger="hover">
                            <img v-if="scope.row.resim" :src="imagepath+scope.row.resim"
                                 :alt="scope.row.baslik">
                            <i style="font-size: 24px; cursor: pointer; color: #337ab7" slot="reference"
                               class="el-icon-picture"></i>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column
                        sortable
                        prop="sayac"
                        label="Sayaç"
                        width="auto">
                </el-table-column>
                <el-table-column
                        prop="sayfaTipi"
                        label="Sayfa Tipi"
                        width="auto">
                </el-table-column>
                <el-table-column
                        label="İşlem"
                        align="right"
                        width="auto">
                    <template slot-scope="scope">
                        <el-tooltip :content='scope.row.olusturan+" / "+scope.row.olusumTarihi' :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    type="text"
                                    icon="mdi mdi-account mdi-24px">
                            </el-button>
                        </el-tooltip>
                        <el-tooltip :content='$t("src.views.apps.sayfa.liste.sayfadetay")' :open-delay="500"
                                    placement="bottom">
                            <el-link target="_blank" icon="mdi mdi-redo-variant mdi-24px" class="margin-bottom-7"
                                     :underline="false"
                                     :href="path+scope.row.link">
                            </el-link>
                        </el-tooltip>
                        <el-tooltip :content='$t("src.views.apps.sayfa.liste.sayfaduzenle")'
                                    :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    v-if="root || yetkiList.sayfaGuncelleme"
                                    v-on:click="routeSayfa('Sayfa Güncelle',scope.row)"
                                    type="text"
                                    class="buttonEdit"
                                    icon="el-icon-edit">
                            </el-button>
                        </el-tooltip>
                        <el-tooltip :content='$t("src.views.apps.sayfa.liste.yayindanKaldir")' :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    v-if="selectIcon==='1' && (root || yetkiList.sayfaDurumGuncelleme)"
                                    class="buttonDel"
                                    type="text"
                                    @click="deleteDialogVisible = true; selection = scope.row; selectionIndex = scope.$index"
                                    icon="mdi mdi-pause mdi-24px">
                            </el-button>
                        </el-tooltip>
                        <el-tooltip :content='$t("src.views.apps.sayfa.liste.yayindanKaldir")' :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    v-if="selectIcon==='0' && (root || yetkiList.sayfaDurumGuncelleme)"
                                    @click="addDialogVisible = true; selection = scope.row; selectionIndex = scope.$index"
                                    size="mini"
                                    type="text"
                                    icon="mdi mdi-play mdi-24px">
                            </el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    background
                    layout="sizes,prev, pager, next, jumper, total"
                    :total="total"
                    @size-change="handleSizeChange"
                    @current-change="pageChange"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page.sync="page"
                    :next-click.sync="page"
                    :prev-click.sync="page"
                    @next-click="pageChange"
                    @prev-click="pageChange">
            </el-pagination>
        </div>
        <el-dialog
                :title='$t("src.views.apps.sayfa.liste.uyari")'
                :visible.sync="deleteDialogVisible"
                width="30%"
                center>
            <span>'{{selection.baslik}}' {{$t('src.views.apps.sayfa.liste.sayfataslak')}}</span>
            <span slot="footer" class="dialog-footer">
                    <el-button icon="el-icon-check"
                               type="success"
                               size="mini"
                               @click="changeSayfaDurum(selection,selectionIndex,sayfalarListesi,'0'), deleteDialogVisible = false"></el-button>
                    <el-button type="danger" size="mini" icon="el-icon-close"
                               @click="deleteDialogVisible = false"></el-button>
                </span>
        </el-dialog>
        <el-dialog
                :title='$t("src.views.apps.sayfa.liste.uyari")'
                :visible.sync="addDialogVisible"
                width="30%"
                center>
            <span>'{{selection.baslik}}' {{$t('src.views.apps.sayfa.liste.sayfaadd')}}</span>
            <span slot="footer" class="dialog-footer">
                    <el-button icon="el-icon-check"
                               type="success"
                               size="mini"
                               @click="changeSayfaDurum(selection,selectionIndex,sayfalarListesi,'1'), addDialogVisible = false"></el-button>
                    <el-button type="danger" size="mini" icon="el-icon-close"
                               @click="addDialogVisible = false"></el-button>
                </span>
        </el-dialog>
    </div>

</template>

<script>
    import sayfaService from '../../../WSProvider/SayfaService'
    import notification from '../../../notification'
    import JQuery from 'jquery';

    let $ = JQuery;
    let base64 = require('base64_js');
    let userDataEstas = "";

    export default {
        name: "SayfaListesi",
        data() {
            return {
                selectIcon: '1',
                radio: '1',
                root: false,
                yetkiList: {
                    sayfaGuncelleme: false,
                    sayfaDurumGuncelleme: false,
                },
                dil: 'tr',
                imagepath: sayfaService.imageUrlKucuk,
                path: sayfaService.path,
                sizes: 10,
                page: 0,
                postPage: 0,
                total: null,
                sayfalarListesi: [],
                deleteDialogVisible: false,
                addDialogVisible: false,
                selection: '',
                selectionIndex: '',
            }
        },
        mounted() {
            let self = this;
            if (localStorage.getItem("userDataEstas")) {
                userDataEstas = JSON.parse(base64.decode(localStorage.getItem("userDataEstas")));
                if (userDataEstas["tur"]) {
                    if (userDataEstas["tur"] === '1' || userDataEstas["tur"] === '2') {
                        self.root = true;
                        self.yetkiList.sayfaDurumGuncelleme = true;
                        self.yetkiList.sayfaGuncelleme = true;
                    }
                } else if (userDataEstas["yetki"]) {
                    userDataEstas["yetki"].forEach(function (value) {
                        switch (value.yetkiKodu) {
                            case 'YK-440561':
                                self.yetkiList.sayfaGuncelleme = true;
                                self.yetkiList.sayfaDurumGuncelleme = true;
                                break;
                            case 'YK-322737':
                                self.yetkiList.sayfaDurumGuncelleme = true;
                                break;
                        }
                    });
                }
            }
            this.sayfaCount();
            this.getSayfaList();
        },
        methods: {
            handleSizeChange(val) {
                this.sizes = val;
                this.getSayfaList();
            },
            pageChange(val) {
                this.postPage = (val - 1) * this.sizes;
                this.getSayfaList();
            },
            dilChange(tab) {
                if (tab.label) {
                    this.dil = tab.label;
                } else {
                    this.dil = tab;
                }
                this.getSayfaList();
            },
            handleChange(event) {
                this.selectIcon = event;
                this.sayfaCount();
                this.getSayfaList();
            },
            sayfaCount() {
                sayfaService.sayfaCount(this.selectIcon).then((response) => {
                    if (response.status === 200) {
                        this.total = parseInt(response.data.count);
                    }
                });
            },
            getSayfaList() {
                sayfaService.sayfaList(this.postPage, this.sizes, this.selectIcon, this.dil).then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            switch (e.kategori) {
                                case '1':
                                    e.sayfaTipi = "Statik";
                                    break;
                                case '2':
                                    e.sayfaTipi = "Dinamik";
                                    break;
                            }
                        });
                        this.sayfalarListesi = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            routeSayfa(name, scope) {
                var tabList = this.$store.state.tabList;
                if (scope) {
                    this.$store.commit('changeUpdateKodu', scope.sayfaKodu);
                }
                var header = linkTemizle(name.replace(" ", ""));
                var obj = tabList.find(data => data.title === name);
                if (obj === undefined) {
                    tabList.push({
                        title: name,
                        name: header,
                        contentName: header
                    });
                    this.$store.commit('changeTabList', tabList);
                    this.$store.commit('changeActiveTabs', header);
                } else {
                    this.$store.commit('changeActiveTabs', header);
                }
            },
            changeSayfaDurum(selection, index, list, durum) {
                sayfaService.sayfaDurumChange(selection.sayfaKodu, durum).then((response) => {
                    if (response.status === 200) {
                        list.splice(index, 1);
                        switch (durum) {
                            case '0':
                                notification.Status("success", this, "Sayfa taslağa taşındı.");
                                break;
                            case '1':
                                notification.Status("success", this, "Sayfa yayına alındı.");
                                break;
                        }
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
        }
    }

    function linkTemizle(text) {
        var trMap = {
            'çÇ': 'c',
            'ğĞ': 'g',
            'şŞ': 's',
            'üÜ': 'u',
            'ıİ': 'i',
            'öÖ': 'o'
        };
        for (var key in trMap) {
            text = text.replace(new RegExp('[' + key + ']', 'g'), trMap[key]);
        }
        return text.replace(/[^-a-zA-Z0-9\s]+/ig, '')
            .replace(/\s/gi, "-")
            .replace(/[-]+/gi, "-")

    }
</script>

<style lang="scss" scoped>
    .el-pagination {
        margin-top: 20px;
        float: right;
    }

    .el-radio-button--mini .el-radio-button__inner label {
        position: relative;
        bottom: 5px;
    }

    .kaldirilmis {
        background: #ec205f;
        color: white;
        font-weight: bold;
        font-size: 16px;
        padding: 10px
    }

</style>
<style lang="scss">
    .slide-fade-enter-active {
        transition: all .3s ease;
    }


    @media (min-width: 768px) {
        .el-radio-button--mini .el-radio-button__inner {
            padding: 0 10px !important;
            font-size: 11px;
            border-radius: 0;
        }
    }


    .slide-fade-leave-active {
        transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }
</style>